import { useEffect, useState } from 'react'
import { useParams, useHistory, Route, Switch } from 'react-router-dom'
import Layout from 'containers/Layout'
import apiGet from 'lib/network/apiGet'
import { getResourceData } from 'lib/utils/resource'
import BookingInvoiceProfile from './BookingInvoiceProfile'

const AddEditBookingInvoice = ({ readOnly, currentInvoiceId }) => {
  const history = useHistory()
  const [invoiceData, setInvoiceData] = useState({})
  const [loading, setLoading] = useState(false)
  const id = useParams()?.id
  const isEdit = !!id

  useEffect(() => {
    if (id) {
      fetchInvoice()
    }
  }, [id])

  const fetchInvoice = async () => {
    setLoading(true)
    try {
      const data = getResourceData(await apiGet(`booking-invoice/${id}`))

      if (!data) {
        history.push('/booking-invoices')
        return
      }

      setInvoiceData(data)
    } catch (error) {
      history.push('/booking-invoices')
    }
    setLoading(false)
  }

  return (
    <Layout
      headerRight={
        <div className="mt-4 flex sm:mt-0 sm:ml-4">
          <button
            onClick={() => {
              history.push('/booking-invoices')
            }}
            type="button"
            className="order-0 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm text-normal rounded-md text-white bg-dark-600 hover:bg-dark-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dark-500 sm:order-1 sm:ml-3"
          >
            Back to Invoices
          </button>
        </div>
      }
      title="Invoice Details"
      breadcrumbs={[
        { name: 'Booking Invoices', pathname: '/booking-invoices' },
        { name: 'Invoice Details', pathname: `/booking-invoice/${id}`, current: true },
      ]}
    >
      <div className="flex overflow-auto">
        {currentInvoiceId ? (
          <BookingInvoiceProfile readOnly={readOnly} refetch={fetchInvoice} invoiceData={invoiceData} loading={loading} id={id} isEdit={isEdit} />
        ) : (
          <Switch>
            <Route
              key={id}
              path="/booking-invoice/:id"
              component={() => <BookingInvoiceProfile readOnly={readOnly} refetch={fetchInvoice} invoiceData={invoiceData} loading={loading} id={id} isEdit={isEdit} />}
            />
          </Switch>
        )}
      </div>
    </Layout>
  )
}

export default AddEditBookingInvoice
